import axios from './settingInstance'

type UpsertSettingParams = {
  key: string
  value: unknown
}

const isSettingNotFoundError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false

  const response = (error as { response?: unknown }).response
  if (!response || typeof response !== 'object') return false

  const data = (response as { data?: unknown }).data
  if (!data || typeof data !== 'object') return false

  return (data as { error?: unknown }).error === 'setting_not_found'
}

export default async ({ key, value }: UpsertSettingParams) => {
  try {
    const response = await axios.put(`/settings/${encodeURIComponent(key)}`, { value })
    return response.data
  } catch (error) {
    if (!isSettingNotFoundError(error)) throw error

    const response = await axios.post('/settings', { key, value })
    return response.data
  }
}
